/* styles/tiles */ function _(require, module, exports) {
    require(311) /* ./root */;
    var _a = require(5) /* ../core/dom */;
    _a.styles.append(".bk-root .bk-tile-attribution a {\n  color: black;\n}\n");
    exports.bk_tile_attribution = "bk-tile-attribution";
}
